if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.zoomLevel = 1;
        this.setupZoomControls();
        this.setupNavigationControls(); // Add this line
        this.setupFullscreenControl();
      }

      setupZoomControls() {
        const zoomIn = this.querySelector('.modal-zoom-in');
        const zoomOut = this.querySelector('.modal-zoom-out');
        
        if (zoomIn) {
          zoomIn.addEventListener('click', () => this.zoom(1.2));
        }
        if (zoomOut) {
          zoomOut.addEventListener('click', () => this.zoom(0.8));
        }
      }

      // Add this new method
      setupNavigationControls() {
        const prevButton = this.querySelector('.modal-nav-button.prev');
        const nextButton = this.querySelector('.modal-nav-button.next');
        
        if (prevButton) {
          prevButton.addEventListener('click', () => this.showPreviousMedia());
        }
        if (nextButton) {
          nextButton.addEventListener('click', () => this.showNextMedia());
        }

        // Also setup thumbnail clicks
        const thumbnails = this.querySelectorAll('.modal-thumbnail');
        thumbnails.forEach(thumbnail => {
          thumbnail.addEventListener('click', (e) => {
            const mediaId = thumbnail.getAttribute('data-media-id');
            const targetMedia = this.querySelector(`[data-media-id="${mediaId}"]`);
            if (targetMedia && !targetMedia.classList.contains('modal-thumbnail')) {
              this.openedBy = thumbnail;
              this.showActiveMedia();
            }
          });
        });
      }

      setupFullscreenControl() {
  const fullscreenBtn = this.querySelector('.modal-fullscreen');
  
  if (fullscreenBtn) {
    fullscreenBtn.addEventListener('click', () => this.toggleFullscreen());
  }

  // Listen for fullscreen changes
  document.addEventListener('fullscreenchange', () => {
    this.handleFullscreenChange();
  });
}

toggleFullscreen() {
  if (!document.fullscreenElement) {
    this.requestFullscreen().catch(err => {
      console.error(`Error attempting to enable fullscreen: ${err.message}`);
    });
  } else {
    document.exitFullscreen();
  }
}

handleFullscreenChange() {
  const fullscreenBtn = this.querySelector('.modal-fullscreen');
  if (fullscreenBtn) {
    const isFullscreen = document.fullscreenElement === this;
    fullscreenBtn.setAttribute('aria-label', isFullscreen ? 'Exit fullscreen' : 'Toggle fullscreen');
  }
}

      zoom(factor) {
        const activeMedia = this.querySelector('.active img, .active video');
        if (activeMedia) {
          this.zoomLevel *= factor;
          this.zoomLevel = Math.max(1, Math.min(3, this.zoomLevel));
          activeMedia.style.transform = `scale(${this.zoomLevel})`;
        }
      }

      hide() {
        super.hide();
        this.zoomLevel = 1;
        const activeMedia = this.querySelector('.active img, .active video');
        if (activeMedia) {
          activeMedia.style.transform = 'scale(1)';
        }
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
        this.addKeyboardControls();
      }

      addKeyboardControls() {
        const handleKeydown = (e) => {
          if (e.key === 'ArrowLeft') this.showPreviousMedia();
          if (e.key === 'ArrowRight') this.showNextMedia();
          if (e.key === 'Escape') this.hide();
        };
        
        document.addEventListener('keydown', handleKeydown);
        this.addEventListener('close', () => {
          document.removeEventListener('keydown', handleKeydown);
        });
      }

      showActiveMedia() {
        // Get all media items (exclude thumbnails)
        const allMediaItems = Array.from(
          this.querySelectorAll('.product-media-modal__item[data-media-id]')
        );
        
        // Remove active class from all items
        allMediaItems.forEach(element => {
          element.classList.remove('active');
        });
        
        // Find and activate the target media
        const targetMediaId = this.openedBy.getAttribute('data-media-id');
        const activeMedia = this.querySelector(`.product-media-modal__item[data-media-id="${targetMediaId}"]`);
        
        if (activeMedia) {
          const activeMediaTemplate = activeMedia.querySelector('template');
          const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
          
          activeMedia.classList.add('active');
          activeMedia.scrollIntoView({ behavior: 'smooth', block: 'center' });

          const container = this.querySelector('[role="document"]');
          if (container) {
            container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;
          }

          if (
            activeMedia.nodeName == 'DEFERRED-MEDIA' &&
            activeMediaContent &&
            activeMediaContent.querySelector('.js-youtube')
          ) {
            activeMedia.loadContent();
          }

          this.updateCounter();
          this.updateThumbnails(targetMediaId);
        }
      }

      showNextMedia() {
        const allMedia = Array.from(
          this.querySelectorAll('.product-media-modal__item[data-media-id]')
        );
        const currentIndex = allMedia.findIndex(media => media.classList.contains('active'));
        const nextIndex = (currentIndex + 1) % allMedia.length;
        
        allMedia[currentIndex].classList.remove('active');
        allMedia[nextIndex].classList.add('active');
        allMedia[nextIndex].scrollIntoView({ behavior: 'smooth', block: 'center' });
        
        const nextMediaId = allMedia[nextIndex].getAttribute('data-media-id');
        this.updateCounter();
        this.updateThumbnails(nextMediaId);
        
        // Reset zoom when changing images
        this.zoomLevel = 1;
        const activeMedia = allMedia[nextIndex].querySelector('img, video');
        if (activeMedia) {
          activeMedia.style.transform = 'scale(1)';
        }
      }

      showPreviousMedia() {
        const allMedia = Array.from(
          this.querySelectorAll('.product-media-modal__item[data-media-id]')
        );
        const currentIndex = allMedia.findIndex(media => media.classList.contains('active'));
        const prevIndex = currentIndex === 0 ? allMedia.length - 1 : currentIndex - 1;
        
        allMedia[currentIndex].classList.remove('active');
        allMedia[prevIndex].classList.add('active');
        allMedia[prevIndex].scrollIntoView({ behavior: 'smooth', block: 'center' });
        
        const prevMediaId = allMedia[prevIndex].getAttribute('data-media-id');
        this.updateCounter();
        this.updateThumbnails(prevMediaId);
        
        // Reset zoom when changing images
        this.zoomLevel = 1;
        const activeMedia = allMedia[prevIndex].querySelector('img, video');
        if (activeMedia) {
          activeMedia.style.transform = 'scale(1)';
        }
      }

      updateCounter() {
        const allMedia = Array.from(
          this.querySelectorAll('.product-media-modal__item[data-media-id]')
        );
        const currentIndex = allMedia.findIndex(media => media.classList.contains('active'));
        const counter = this.querySelector('.modal-counter');
        
        if (counter) {
          counter.textContent = `${currentIndex + 1} / ${allMedia.length}`;
        }
      }

      updateThumbnails(activeMediaId) {
        const thumbnails = this.querySelectorAll('.modal-thumbnail');
        thumbnails.forEach(thumbnail => {
          if (thumbnail.getAttribute('data-media-id') === activeMediaId) {
            thumbnail.classList.add('active');
          } else {
            thumbnail.classList.remove('active');
          }
        });
      }
    }
  );
}

// Image Magnifier Component
if (!customElements.get('image-magnifier')) {
  customElements.define(
    'image-magnifier',
    class ImageMagnifier extends HTMLElement {
      constructor() {
        super();
        this.magnifierEnabled = this.dataset.magnifyEnabled === 'true';
        this.lightboxEnabled = this.dataset.lightboxEnabled === 'true';
        this.zoomLevel = this.dataset.zoomLevel || 2.5;
        
        if (this.magnifierEnabled) {
          this.init();
        }
      }

      init() {
        this.image = this.querySelector('img');
        if (!this.image) return;

        this.createMagnifier();
        this.attachEvents();
      }

      createMagnifier() {
        // Create magnifier lens
        this.lens = document.createElement('div');
        this.lens.classList.add('image-magnifier-lens');
        this.appendChild(this.lens);

        // Create result container for zoomed image
        this.result = document.createElement('div');
        this.result.classList.add('image-magnifier-result');
        this.appendChild(this.result);

        // Set background image for result
        this.result.style.backgroundImage = `url('${this.image.src}')`;
        this.result.style.backgroundSize = `${this.image.width * this.zoomLevel}px ${this.image.height * this.zoomLevel}px`;
      }

      attachEvents() {
        // Mouse events for magnifier
        this.image.addEventListener('mouseenter', (e) => this.showMagnifier(e));
        this.image.addEventListener('mousemove', (e) => this.moveMagnifier(e));
        this.image.addEventListener('mouseleave', () => this.hideMagnifier());

        // Click event for lightbox
        if (this.lightboxEnabled) {
          this.image.addEventListener('click', (e) => {
            // Only open lightbox if not dragging
            if (!this.isDragging) {
              this.openLightbox();
            }
          });
        }

        // Touch events for mobile
        let touchTimeout;
        this.image.addEventListener('touchstart', (e) => {
          touchTimeout = setTimeout(() => {
            this.showMagnifier(e.touches[0]);
          }, 200);
        });

        this.image.addEventListener('touchmove', (e) => {
          clearTimeout(touchTimeout);
          if (this.lens.classList.contains('active')) {
            e.preventDefault();
            this.moveMagnifier(e.touches[0]);
          }
        });

        this.image.addEventListener('touchend', () => {
          clearTimeout(touchTimeout);
          this.hideMagnifier();
        });
      }

      showMagnifier(e) {
        this.lens.classList.add('active');
        this.result.classList.add('active');
        this.moveMagnifier(e);
      }

      moveMagnifier(e) {
        e.preventDefault();
        
        const bounds = this.image.getBoundingClientRect();
        let x = e.clientX - bounds.left;
        let y = e.clientY - bounds.top;

        // Prevent lens from going outside image
        const lensWidth = this.lens.offsetWidth / 2;
        const lensHeight = this.lens.offsetHeight / 2;

        x = Math.max(lensWidth, Math.min(x, bounds.width - lensWidth));
        y = Math.max(lensHeight, Math.min(y, bounds.height - lensHeight));

        // Position the lens
        this.lens.style.left = `${x - lensWidth}px`;
        this.lens.style.top = `${y - lensHeight}px`;

        // Calculate background position for result
        const cx = this.result.offsetWidth / this.lens.offsetWidth;
        const cy = this.result.offsetHeight / this.lens.offsetHeight;

        this.result.style.backgroundPosition = `-${x * cx - this.result.offsetWidth / 2}px -${y * cy - this.result.offsetHeight / 2}px`;
      }

      hideMagnifier() {
        this.lens.classList.remove('active');
        this.result.classList.remove('active');
      }

      openLightbox() {
        const mediaId = this.image.dataset.mediaId;
        const modal = document.querySelector('product-modal');
        const trigger = document.querySelector(`[data-media-id="${mediaId}"]`);
        
        if (modal && trigger) {
          modal.show(trigger);
        }
      }
    }
  );
}